<template>
  <div class="ad-container">
    <div class="padding-lr-16">
      <p>发票详情</p>
      <div class="ad-body-box">
        <div class="flex justify-between">
          <p class="text-grey1">发票类型</p>
          <p>电子发票</p>
        </div>
        <div class="flex justify-between">
          <p class="text-grey1">发票抬头</p>
          <p>{{ detailInfo.name }}</p>
        </div>
        <div class="flex justify-between">
          <p class="text-grey1">发票内容</p>
          <p>客运服务费</p>
        </div>
        <div class="flex justify-between">
          <p class="text-grey1">发票金额</p>
          <p>{{ parseInt(detailInfo.amount) * 0.01 }}元</p>
        </div>
        <div class="flex justify-between">
          <p class="text-grey1">提交时间</p>
          <p>{{ detailInfo.applyTime }}</p>
        </div>
      </div>
    </div>
    <!-- 接收方式 -->
    <div class="padding-lr-16">
      <p>接收方式</p>
      <div class="ad-body-box">
        <div class="flex justify-between">
          <p class="text-grey1">电子邮箱</p>
          <p>{{ detailInfo.email }}</p>
        </div>
        <div class="flex justify-between">
          <p class="text-grey1">开票状态</p>
          <div>
            <div v-if="detailInfo.invoiceStatus === 'ISSUED'">已开具</div>
            <div v-if="detailInfo.invoiceStatus === 'REVERSED'">已作废</div>
            <div v-if="detailInfo.invoiceStatus === 'REOPEN'">已重开</div>
          </div>
        </div>
        <div
          class="flex justify-between"
          @click="$router.push('/invoice/stroke')"
        >
          <p class="text-grey1">所含行程</p>
          <p>{{ orderEntityList.length }}</p>
        </div>
      </div>
    </div>
    <!-- 发票提供方 -->
    <div class="padding-lr-16">
      <p>发票提供方</p>
      <div class="ad-body-box">
        <div class="flex justify-between">
          <p class="text-grey1">提供方</p>
          <p>滇约出行</p>
        </div>
      </div>
      <div class="flex">
        <van-image
          width="1rem"
          height="1rem"
          fit="contain"
          class="notice margin-left-10"
          :src="require('assets/images/kfp/noticeOne.png')"
        />
        <p class="text-12 text-grey1 margin-left-10">
          如对发票有疑问，请联系客服
        </p>
      </div>
      <div class="flex justify-between">
        <van-button @click="showPopup" class="btn">重发发票和行程单</van-button>
        <van-button
          v-if="detailInfo.invoiceStatus === 'ISSUED'"
          class="btn"
          @click="$router.push('/invoice/reInvoice')"
          >申请重开发票</van-button
        >
      </div>
      <van-popup
        v-model="show"
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <div class="margin-20">
          <p>发送到</p>
          <div>
            <van-field
              v-model="detailInfo.email"
              required
              placeholder="请输入您的邮箱"
            />
          </div>
          <p>
            <span></span
            ><span class="text-10 text-grey1"
              >电子发票需要在一定时间才能发送到你的邮箱，请耐心等待</span
            >
          </p>
          <van-button class="btn" @click="sendInvoiceToEmail"
            >确认发送</van-button
          >
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { getInvoiceRecordDetail, sendInvoiceToEmail } from 'api/invoice'
export default {
  data () {
    return {
      detailInfo: '',
      fillFrom: {
        recipient: '',
        phone: '',
        email: ''
      },
      checked: true,
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      radio: '1',
      value: '',
      orderEntityList: [],
      show: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList () {
      this.res = await getInvoiceRecordDetail({
        id: this.$route.params.id
      })
      // 发票详情
      this.detailInfo = this.res.invoiceRecordEntity
      // 订单信息
      this.orderEntityList = this.res.orderEntityList
      window.localStorage.setItem('detailInfo', JSON.stringify(this.detailInfo))
      window.localStorage.setItem(
        'orderEntityList',
        JSON.stringify(this.orderEntityList)
      )
    },
    showPopup () {
      this.show = true
    },
    sendInvoiceToEmail () {
      var data
      this.show = false
      if (this.detailInfo.reOpenAppId) {
        data = {
          id: this.detailInfo.reOpenAppId,
          email: this.detailInfo.email
        }
      } else {
        data = {
          id: this.detailInfo.id,
          email: this.detailInfo.email
        }
      }
      sendInvoiceToEmail(data)
        .then(res => {
          console.log(res)
          this.$toast('发送成功，请注意查收')
        })
        .catch(() => {})
        .finally(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-body-box {
  background-color: #fff;
  position: relative;
  z-index: 1;
  border-radius: 4px;
  box-shadow: 0 0 12px 0 #eee;
  padding: 0 8px;
}
.titleTwo {
  margin-top: -14px;
}
.notice {
  margin-top: 16px;
}
.bg-title {
  background-color: #fbd3926b;
  width: 100%;
}
.distance {
  margin-top: 20px;
}
.list {
  margin-top: 17px;
}
.button {
  border-radius: 50px;
  width: 90%;
  margin-top: 20px;
  background-color: #ff7307;
  margin-left: 16px;
}
.btn {
  border-radius: 550px;
  width: 100%;
  background-color: rgba(255, 111, 0, 0.781);
  color: #fff;
}
.btn:active {
  background-color: #ff7307;
}
</style>
